import { IDataStoreActions } from '@/interfaces/actions/enact/IDataStoreActions.ts';
import { useDataStore } from '@/stores/powerMarkets/dataStore.ts';
import { dataStoreApi } from '@/api/powerMarkets/dataStoreApi.ts';

const useDataStoreActions = (): IDataStoreActions => {
    const dataStore = useDataStore();

    async function getPlantStore (): Promise<boolean> {
        return dataStoreApi.getPlantStore().then(res => {
            if (!res.data) return false;
            dataStore.updatePlantsStore(res.data);
            return true;
        }).catch(() => false);
    }

    async function getSearchDefinitions (): Promise<boolean> {
        return dataStoreApi.getSearchDefinitions().then(res => {
            dataStore.updateSearchDefinitions(res.data);
            return true;
        }).catch(() => false);
    }

    async function getPeriodData (): Promise<boolean> {
        return dataStoreApi.getPeriodData().then(res => {
            dataStore.updatePeriodData(res.data);
            return true;
        }).catch(() => false);
    }

    return {
        getPlantStore,
        getSearchDefinitions,
        getPeriodData,
    };
};

export { useDataStoreActions };
